import {
  PenTool, Rocket, Briefcase, ShoppingCart, Sparkles, Layers, ShieldCheck, ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/data/portfolio";
import { useReveal } from "@/hooks/useReveal";

const iconMap = { PenTool, Rocket, Briefcase, ShoppingCart, Sparkles, Layers, ShieldCheck };

export default function Services() {
  const { ref, visible } = useReveal();

  return (
    <section id="services" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10" ref={ref}>
        <div className={`flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 fade-in-up ${visible ? "in" : ""}`}>
          <div>
            <div className="section-label mb-4">Services</div>
            <h2 className="heading-hero text-4xl md:text-5xl lg:text-6xl">
              Everything you need,<br/>
              <span className="text-[#FF3B30]">shipped end-to-end.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md">
            From landing pages that convert to full e-commerce platforms — pick what fits your business.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = iconMap[s.icon] || PenTool;
            return (
              <div
                key={s.key}
                className={`glass-card rounded-3xl p-7 group cursor-pointer fade-in-up ${visible ? "in" : ""}`}
                style={{ transitionDelay: `${i * 60}ms` }}
                data-testid={`service-card-${s.key}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 rounded-2xl bg-[#FF3B30]/10 border border-[#FF3B30]/25 grid place-items-center text-[#FF3B30] group-hover:bg-[#FF3B30] group-hover:text-white transition-colors">
                    <Icon size={22} />
                  </div>
                  <span className="text-white/30 group-hover:text-[#FF3B30] transition-colors">
                    <ArrowUpRight size={20} />
                  </span>
                </div>
                <h3 className="font-display font-bold text-xl mb-2 leading-tight">{s.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
